import { Controller } from "@hotwired/stimulus"

// Toggles visibility of "one gym" vs "multiple gyms" based on redeemable scope radio.
// Ensures only the relevant fields are visible and clears irrelevant values on switch.
export default class extends Controller {
  static targets = ["organisationOption", "oneGymOption", "gymsOption", "oneGymField", "gymsField", "scopeInput"]

  connect() {
    this.syncVisibility()
  }

  change(event) {
    const value = event.target.value
    if (this.hasScopeInputTarget) this.scopeInputTarget.value = value
    this.syncVisibility(value)
    if (value === "organisation") {
      this.clearGymFields()
    } else if (value === "gym") {
      this.clearGymsField()
    } else if (value === "gyms") {
      this.clearOneGymField()
    }
  }

  syncVisibility(scopeValue) {
    const scope = scopeValue ?? (this.hasScopeInputTarget ? this.scopeInputTarget.value : "")
    const showOne = scope === "gym"
    const showGyms = scope === "gyms"

    if (this.hasOneGymFieldTarget) {
      this.oneGymFieldTarget.classList.toggle("hidden", !showOne)
      this.oneGymFieldTarget.querySelector("select")?.toggleAttribute("disabled", !showOne)
    }
    if (this.hasGymsFieldTarget) {
      this.gymsFieldTarget.classList.toggle("hidden", !showGyms)
      this.gymsFieldTarget.querySelectorAll("input[type=checkbox]").forEach((el) => {
        el.toggleAttribute("disabled", !showGyms)
      })
    }
  }

  clearGymFields() {
    this.clearOneGymField()
    this.clearGymsField()
  }

  clearOneGymField() {
    if (this.hasOneGymFieldTarget) {
      const select = this.oneGymFieldTarget.querySelector("select")
      if (select) select.value = ""
    }
  }

  clearGymsField() {
    if (this.hasGymsFieldTarget) {
      this.gymsFieldTarget.querySelectorAll("input[type=checkbox]").forEach((cb) => {
        cb.checked = false
      })
    }
  }
}
